import { call, put } from 'redux-saga/effects';
import GetLeavesCancelActions from '../redux/GetLeavesCancelRedux';
import { api } from './api';


export function* getleavescancelsagas(action: any): Generator<any, void, any> {
  const { children_id, page } = action;
  const response = yield call(api.getLeavesCancel, children_id, page);

  // success?
  if (response.ok) {
    // You might need to change the response here - do this with a 'transform',
    // located in ../Transforms/. Otherwise, just pass the data back from the api.
    yield put(GetLeavesCancelActions.getLeavesCancelSuccess(response.data));
  } else {
    yield put(GetLeavesCancelActions.getLeavesCancelFailure());
  }
}